import type { FactorFormState, RollupSimulateRequest } from '../../../types/statusFactors';
import { toStored, fromStored } from '../RelatedSpheresEditor/combineModel';
import { compileSet } from '../RollupSetCard/rollupSetModel';

/**
 * The unsaved rollup edit as the simulate route reads it. Guardrails that are off are sent as `null`, so the
 * simulation evaluates the form, not whatever is stored. Exclusions are omitted: the roster routes own them.
 */
export function buildSimulateCandidate(localData: FactorFormState): RollupSimulateRequest {
  const combine = toStored(fromStored(localData));
  return {
    aggregationMethod: combine.aggregationMethod,
    weighting: combine.weighting,
    influenceFloor: localData.influenceFloor,
    // Same value the save sends (useStatusFactorsState), so a stored 0.755 previews as 0.755, not the rounded 0.76.
    minCoverage: localData.coverageFloor
      ? localData.coverageFloor.exact ?? localData.coverageFloor.percent / 100
      : null,
    belowCoverageStatus: localData.coverageFloor ? localData.coverageFloor.status : null,
    childPerspective: localData.childPerspective,
    populationSources: [...compileSet(localData.rollupSet), ...(localData.preservedPopulationSourcesTail ?? [])],
  };
}
